import React from 'react'
import { Modal } from 'react-bootstrap'
import i18n from 'i18next'
import { AvailabilityCalendar } from './AvailabilityCalendar'
import { StyledModal } from './style'
import {
  AvailabilityCalendarRoom,
  AvailabilityScheduleInput,
} from './types'

interface AvailabilityCalendarModalProps {
  isOpen: boolean
  onClose: () => void
  rooms: AvailabilityCalendarRoom[]
  settings?: AvailabilityScheduleInput | null
}

export const AvailabilityCalendarModal = ({
  isOpen,
  onClose,
  rooms,
  settings = null,
}: AvailabilityCalendarModalProps): JSX.Element => (
  <StyledModal show={isOpen} onHide={onClose} centered size="xl">
    <Modal.Header closeButton>
      <Modal.Title>
        {i18n.t('meetingRoom.public.availability.title')}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <AvailabilityCalendar
        rooms={rooms}
        settings={settings}
        isActive={isOpen}
        variant="modal"
      />
    </Modal.Body>
  </StyledModal>
)

export { AvailabilityCalendar } from './AvailabilityCalendar'
